/**
 * Because of Webpack 5's new way of initializing web workers (through creating a URL and passing import.meta.url)
 * our jest unit tests started breaking.
 *
 * Web-workers should now only be instantiated be extracting them into their own function and file, which then should be mocked inside `setup-jest.ts`.
 *
 * https://stackoverflow.com/questions/64961387/how-to-use-import-meta-when-testing-with-jest/69796349#69796349
 */
export const FeatureWasmGitWebWorker = new Worker(new URL('./feature-wasm-git.worker', import.meta.url), {
  type: 'module',
});
